import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "@/context/ThemeContext";
import { AuthProvider } from "@/context/AuthContext";

import HomePage from "@/pages/HomePage";
import ServicesPage from "@/pages/ServicesPage";
import ServiceDetailPage from "@/pages/ServiceDetailPage";
import IndustriesPage from "@/pages/IndustriesPage";
import IndustryDetailPage from "@/pages/IndustryDetailPage";
import ProductsPage from "@/pages/ProductsPage";
import CertisfyPage from "@/pages/products/CertisfyPage";
import AgriBrain360Page from "@/pages/products/AgriBrain360Page";
import WaldInsightsPage from "@/pages/products/WaldInsightsPage";
import WaldFlowPage from "@/pages/products/WaldFlowPage";
import InsightsListPage from "@/pages/InsightsListPage";
import InsightArticlePage from "@/pages/InsightArticlePage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";
import PrivacyPolicyPage from "@/pages/PrivacyPolicyPage";
import TermsOfUsePage from "@/pages/TermsOfUsePage";
import AdminLoginPage from "@/pages/admin/AdminLoginPage";
import AdminInsightsPage from "@/pages/admin/AdminInsightsPage";
import AdminEnquiriesPage from "@/pages/admin/AdminEnquiriesPage";
import NotFoundPage from "@/pages/NotFoundPage";

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/services" element={<ServicesPage />} />
              <Route path="/services/:slug" element={<ServiceDetailPage />} />
              <Route path="/industries" element={<IndustriesPage />} />
              <Route path="/industries/:slug" element={<IndustryDetailPage />} />
              <Route path="/products" element={<ProductsPage />} />
              <Route path="/products/agribrain-360" element={<AgriBrain360Page />} />
              <Route path="/products/certisfy" element={<CertisfyPage />} />
              <Route path="/products/waldinsights" element={<WaldInsightsPage />} />
              <Route path="/products/waldflow" element={<WaldFlowPage />} />
              <Route path="/insights" element={<InsightsListPage />} />
              <Route path="/insights/:slug" element={<InsightArticlePage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
              <Route path="/terms-of-use" element={<TermsOfUsePage />} />
              <Route path="/admin/login" element={<AdminLoginPage />} />
              <Route path="/admin" element={<AdminInsightsPage />} />
              <Route path="/admin/enquiries" element={<AdminEnquiriesPage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
